import React, { useState, useEffect } from 'react';

const SendMessaging = () => {
    const [groupName, setGroupName] = useState('');
    const [subgroupName, setSubgroupName] = useState('');
    const [groupOptions, setGroupOptions] = useState([]);
    const [groupedContacts, setGroupedContacts] = useState({});
    const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);
    const [greetingMessage, setGreetingMessage] = useState('');
    const [sendMessage, setSendMessage] = useState('');


    const fetchContacts = async () => {
        try {
            const user = JSON.parse(sessionStorage.getItem('user'));
            if (!user || !user.id) {
                console.error('User not logged in');
                return;
            }

            const queryParams = new URLSearchParams();
            queryParams.append('user_id', user.id); // ✅ Append user_id

            if (groupName) queryParams.append('groupName', groupName);
            if (subgroupName) queryParams.append('subgroupName', subgroupName);

            const response = await fetch(`https://rvapi.emedha.in/pages/api/contacts?${queryParams.toString()}`);

            if (!response.ok) {
                throw new Error('Failed to fetch contacts');
            }

            const data = await response.json();

            const groupedData = data.contacts.reduce((acc, contact) => {
                const group = contact.group_name;
                const subgroup = contact.subgroup_name || 'No Subgroup';

                if (!acc[group]) acc[group] = {};
                if (!acc[group][subgroup]) acc[group][subgroup] = [];

                acc[group][subgroup].push({
                    ...contact,
                    group_id: contact.group_id,
                    subgroup_id: contact.subgroup_id,
                });

                return acc;
            }, {});

            setGroupedContacts(groupedData);
            const groups = Object.keys(groupedData);
            setGroupOptions(groups);

            if (groupName) {
                const subgroup = subgroupName || 'No Subgroup';
                const selectedContacts = groupedData[groupName][subgroup] || [];
                setSelectedGroupContacts(selectedContacts);
            }

        } catch (err) {
            console.error('Error fetching contacts:', err);
        }
    };


    const fetchGreetingMessage = async () => {
        try {
            const response = await fetch('https://rvapi.emedha.in/pages/api/getConfig');
            const data = await response.json();

            if (data.success && data.data.length > 0) {
                const greeting = data.data.filter(item => item.type === "rahul" || item.type === "rahul gen");
                if (greeting.length > 0) {
                    setGreetingMessage(greeting.find(item => item.type === "rahul") || null);
                    setSendMessage(greeting.find(item => item.type === "rahul gen") || null);
                } else {
                    setGreetingMessage(null);
                    setSendMessage(null);
                }
            } else {
                setGreetingMessage(null);
                setSendMessage(null);
            }
        } catch (err) {
            console.error('Error fetching greeting message:', err);
            setGreetingMessage(null);
            setSendMessage(null);
        }
    };



    useEffect(() => {
        fetchContacts();
        fetchGreetingMessage();

        if (groupName && groupedContacts[groupName]) {
            const subgroup = subgroupName || 'No Subgroup';
            const contacts = groupedContacts[groupName][subgroup];
            if (Array.isArray(contacts)) {
                setSelectedGroupContacts(contacts);

                console.log('Group Name:', groupName);
                console.log('Subgroup Name:', subgroup);
                console.log('Selected Contacts:', contacts);

                contacts.forEach(contact => {
                    console.log('Contact group_id:', contact.group_id);
                    console.log('Contact subgroup_id:', contact.subgroup_id);
                });
            } else {
                setSelectedGroupContacts([]);
                console.log('No contacts found for the selected group and subgroup');
            }
        }

    }, [groupName, subgroupName]);


    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setSubgroupName('');
        setSelectedGroupContacts([]);
    };

    const handleSubgroupChange = (e) => {
        const subgroup = e.target.value;
        setSubgroupName(subgroup);
        const selectedContacts = groupedContacts[groupName][subgroup || 'No Subgroup'] || [];
        setSelectedGroupContacts(selectedContacts);
    };


    const handleSendMessage = async () => {
        const contactsToSendGreeting = selectedGroupContacts.filter(contact => contact.flag !== 1);

        if (contactsToSendGreeting.length === 0) {
            alert('All selected contacts have flag set to 1. Cannot send greetings to these contacts!. If You want Send greetings Please click on Reset button');
            return;
        }

        if (!selectedGroupContacts || selectedGroupContacts.length === 0) {
            console.error('No contacts selected for sending greeting');
            alert('No contacts selected for sending greeting');
            return;
        }

        if (!sendMessage || !sendMessage.message) {
            console.error('message is not available');
            alert('message is not available');
            return;
        }

        console.log('Selected contacts:', selectedGroupContacts);

        let successCount = 0;
        let failureCount = 0;

        for (const contact of selectedGroupContacts) {
            console.log('Contact:', contact);
            console.log('group_id:', contact.group_id);
            console.log('subgroup_id:', contact.subgroup_id);

            const personalizedMessage = `${greetingMessage.message}`;

            const groupId = contact.group_id;
            const subGroupId = contact.subgroup_id;

            //       https://emedha.com/echatbot/rahulverma/message.php?groupId=45&subGroupId=16

            const sendMessageApiUrl = `https://emedha.com/echatbot/rahulverma/message.php?groupId=${groupId}&subGroupId=${subGroupId}`;

            const payload = {
                groupName: contact.group_name,
                subgroupName: contact.subgroup_name || 'No Subgroup',
                message: personalizedMessage,
                contactMobile: contact.contact_mobile,
                groupId: contact.group_id,
                subgroupId: contact.subgroup_id,
            };

            try {
                const response = await fetch(sendMessageApiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });

                // Check if the response is valid JSON
                const contentType = response.headers.get("content-type");
                if (!contentType || !contentType.includes("application/json")) {
                    throw new Error('Invalid response type');
                }

                const data = await response.json();
                if (data.success) {
                    successCount++;
                } else {
                    failureCount++;
                }
            } catch (error) {
                console.error('Error sending greeting:', error);
                failureCount++;
            }
        }

        if (successCount > 0) {
            alert(`${successCount} greeting(s) successfully sent.`);
        }

        if (failureCount > 0) {
            alert(`${failureCount} greeting(s) failed to send.`);
        }

        if (successCount === 0 && failureCount === 0) {
            alert('No greetings sent.');
        }
    };


    const handleSendGreeting = async () => {
        const contactsToSendGreeting = selectedGroupContacts.filter(contact => contact.flag !== 1);
        if (contactsToSendGreeting.length === 0) {
            alert('All selected contacts have flag set to 1. Cannot send greetings to these contacts!. If You want Send greetings Please click on Reset button');
            return;
        }
        if (!greetingMessage || !greetingMessage.message) {
            console.error('Greeting message is not available');
            alert('Greeting message is not available');
            return;
        }
        console.log('Selected contacts:', contactsToSendGreeting);
        let successCount = 0;
        let failureCount = 0;

        for (const contact of contactsToSendGreeting) {
            const personalizedMessage = `Dear ${contact.contact_name} Ji, Greetings ${greetingMessage.message}`;

            const groupId = contact.group_id;
            const subGroupId = contact.subgroup_id;

            console.log('group_id:', contact.group_id);
            console.log('subgroup_id:', contact.subgroup_id);


            //        https://emedha.com/echatbot/rahulverma/gengreet.php?groupId=45&subGroupId=16

            const greetApiUrl = `https://emedha.com/echatbot/rahulverma/gengreet.php?groupId=${groupId}&subGroupId=${subGroupId}`;

            const payload = {
                groupName: contact.group_name,
                subgroupName: contact.subgroup_name || 'No Subgroup',
                message: personalizedMessage,
                contactMobile: contact.contact_mobile,
                groupId: contact.group_id,
                subgroupId: contact.subgroup_id,
            };
            try {
                const response = await fetch(greetApiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });
                const data = await response.json();
                if (data.success) {
                    console.log(`Greeting sent to ${contact.contact_name} at ${contact.contact_mobile}`);
                    successCount++;
                } else {
                    console.error(`Failed to send greeting to ${contact.contact_name}:`, data.error);
                    failureCount++;
                }
            } catch (error) {
                console.error('Error sending greeting:', error);
                failureCount++;
            }
        }

        if (successCount > 0) {
            alert(`${successCount} greeting(s) successfully sent.`);
        }
        if (failureCount > 0) {
            alert(`${failureCount} greeting(s) failed to send.`);
        }
        if (successCount === 0 && failureCount === 0) {
            alert('No greetings sent.');
        }
    };



    const handleResetFlag = async () => {
        if (groupName && groupedContacts[groupName]) {
            const contactIdsToReset = groupedContacts[groupName][subgroupName || 'No Subgroup']?.map(contact => contact.id);

            try {
                const response = await fetch('https://rvapi.emedha.in/pages/api/reset-flag', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        groupName,
                        subgroupName: subgroupName || 'No Subgroup',
                        contactIds: contactIdsToReset,
                    }),
                });
                const data = await response.json();
                if (data.success) {
                    const updatedContacts = groupedContacts[groupName][subgroupName || 'No Subgroup']?.map(contact => ({
                        ...contact,
                        flag: 0,
                    }));
                    setSelectedGroupContacts(updatedContacts);
                    setGroupedContacts(prevGroupedContacts => {
                        const updatedGroupedContacts = { ...prevGroupedContacts };
                        updatedGroupedContacts[groupName][subgroupName || 'No Subgroup'] = updatedContacts;
                        return updatedGroupedContacts;
                    });
                    console.log('Flag reset successful');
                    alert('Contacts flag reset successful!');
                } else {
                    console.error('Failed to reset flag:', data.error);
                }
            } catch (error) {
                console.error('Error resetting flag:', error);
            }
        }
    };

    const [messageToEdit, setMessageToEdit] = useState('');
    const [headerImageToEdit, setHeaderImageToEdit] = useState('');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [greetingType, setGreetingType] = useState('');

    const handleEditGreeting = (type) => {
        const greetingToEdit = type === 'rahul' ? greetingMessage : (type === 'rahul gen' ? sendMessage : null);
        if (greetingToEdit) {
            setGreetingType(type);
            setMessageToEdit(greetingToEdit.message);
            setHeaderImageToEdit(greetingToEdit.header_image);
            setIsEditModalOpen(true);
        } else {
            console.error('No greeting found to edit');
        }
    };

    const handleUpdateGreeting = async () => {
        const formData = new FormData();
        const greetingToUpdate = greetingType === 'rahul' ? greetingMessage : sendMessage;
        formData.append('id', greetingToUpdate.id);
        formData.append('message', messageToEdit);
        formData.append('type', greetingType);
        if (headerImageToEdit) {
            formData.append('file', headerImageToEdit);
        }
        try {
            const response = await fetch('https://rvapi.emedha.in/pages/api/api/updateGreeting', {
                method: 'PUT',
                body: formData,
            });
            const data = await response.json();
            if (data.success) {
                console.log('Greeting updated successfully');
                if (greetingType === 'rahul') {
                    setGreetingMessage({ ...greetingMessage, message: messageToEdit, header_image: data.header_image });
                } else {
                    setSendMessage({ ...sendMessage, message: messageToEdit, header_image: data.header_image });
                }
                setIsEditModalOpen(false);
            } else {
                console.error('Failed to update greeting');
            }
        } catch (error) {
            console.error('Error updating greeting:', error);
        }
    };



    return (
        <>
            <div style={{ display: 'flex', height: '100vh' }}>
                <div style={{ width: '25%', backgroundColor: '#f8f9fa', borderRight: '1px solid #ddd', padding: '20px', overflowY: 'auto' }}>
                    <h3 style={{ textAlign: 'center' }}>Select Group & Subgroup</h3>
                    <div style={{ marginBottom: '20px' }}>
                        <select value={groupName} onChange={handleGroupChange} style={{ width: '100%', padding: '12px', fontSize: '16px', marginBottom: '15px', borderRadius: '8px', border: '1px solid #ddd' }}>
                            <option value="">Select Group</option>
                            {groupOptions.map((group, index) => (
                                <option key={index} value={group}>{group}</option>
                            ))}
                        </select>

                        {groupName && (
                            <select value={subgroupName} onChange={handleSubgroupChange} style={{ width: '100%', padding: '12px', fontSize: '16px', marginBottom: '15px', borderRadius: '8px', border: '1px solid #ddd' }}>
                                <option value="">Select Subgroup (optional)</option>
                                {Object.keys(groupedContacts[groupName]).map((subgroup, index) => (
                                    <option key={index} value={subgroup}>{subgroup}</option>
                                ))}
                            </select>
                        )}
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <h4 style={{ color: '#6c757d' }}>Contacts</h4>
                        {selectedGroupContacts.length > 0 ? (
                            <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                                {selectedGroupContacts.map((contact) => (
                                    <li key={contact.id} style={{ padding: '10px', backgroundColor: '#f1f1f1', marginBottom: '8px', borderRadius: '5px', cursor: 'pointer', transition: 'background-color 0.3s' }}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                    >
                                        {contact.contact_name} - {contact.contact_mobile}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p style={{ color: '#6c757d' }}>No contacts found in this group/subgroup.</p>
                        )}
                    </div>
                </div>

                <div style={{ width: '75%', padding: '20px', display: 'flex', flexDirection: 'column' }}>
                    <div>
                        <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff', borderBottom: '1px solid #ddd', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h4>{groupName} {subgroupName && `- ${subgroupName}`}</h4>
                            </div>
                            <button onClick={handleResetFlag} style={{ padding: '8px 12px', fontSize: '14px', borderRadius: '8px', backgroundColor: '#6c757d', color: '#fff', border: 'none', cursor: 'pointer' }} >Reset</button>
                        </div>

                        <div style={{ padding: '20px', backgroundColor: '#f1f1f1', height: '80vh', overflowY: 'auto', borderBottom: '1px solid #ddd' }}>
                            {selectedGroupContacts.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                                    {greetingMessage && greetingMessage.header_image && (
                                        <div style={{ display: 'flex', marginBottom: '15px' }}>
                                            <img src={greetingMessage.header_image} alt="Greeting Header" style={{ width: '200px', height: '200px', marginRight: '10px', borderRadius: '8px' }} />
                                            <div>
                                                {greetingMessage && greetingMessage.message && (
                                                    <>
                                                        <p>{greetingMessage.type}</p>
                                                        <p>{greetingMessage.message}</p>
                                                    </>
                                                )}
                                                <button className='me-3' style={{ padding: '8px 12px', fontSize: '14px', borderRadius: '8px', backgroundColor: '#6c757d', color: '#fff', border: 'none', cursor: 'pointer' }} onClick={handleSendMessage}>Send message Only </button>
                                                <button style={{ padding: '8px 12px', fontSize: '14px', borderRadius: '8px', backgroundColor: '#6c757d', color: '#fff', border: 'none', cursor: 'pointer' }} onClick={() => handleEditGreeting('rahul')} >Edit</button>
                                            </div>
                                        </div>
                                    )}

                                    {sendMessage && sendMessage.header_image && (
                                        <div style={{ display: 'flex', marginBottom: '15px' }}>
                                            <img src={sendMessage.header_image} alt="Send Message Header" style={{ width: '200px', height: '200px', marginRight: '10px', borderRadius: '8px' }} />
                                            <div>
                                                {sendMessage && sendMessage.message && (
                                                    <>
                                                        <p>{sendMessage.type}</p>
                                                        <p>{sendMessage.message}</p>
                                                    </>
                                                )}
                                                <button className='me-3' style={{ padding: '8px 12px', fontSize: '14px', borderRadius: '8px', backgroundColor: '#6c757d', color: '#fff', border: 'none', cursor: 'pointer' }} onClick={handleSendGreeting}>Send Name & Message</button>
                                                <button style={{ padding: '8px 12px', fontSize: '14px', borderRadius: '8px', backgroundColor: '#6c757d', color: '#fff', border: 'none', cursor: 'pointer' }} onClick={() => handleEditGreeting('rahul gen')}>Edit</button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            ) : (
                                <p style={{ color: '#6c757d' }}>No members in this group to chat with.</p>
                            )}
                        </div>
                    </div>

                    {!groupName && (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <h4 style={{ color: '#6c757d' }}>Please select a group to start chatting.</h4>
                        </div>
                    )}
                </div>
            </div>

            {isEditModalOpen && (
                <div style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', maxWidth: '500px', width: '100%' }}>
                        <h3>Edit Greeting Message</h3>
                        <div style={{ marginBottom: '10px' }}>
                            <label htmlFor="type">Type</label>
                            <input id="type" type="text" value={greetingType} disabled style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginTop: '5px' }} />
                        </div>
                        <textarea value={messageToEdit} onChange={(e) => setMessageToEdit(e.target.value)} rows="4" style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
                        <input type="file" onChange={(e) => setHeaderImageToEdit(e.target.files[0])} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginTop: '10px' }} />
                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
                            <button onClick={handleUpdateGreeting} style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: '#28a745', color: 'white', border: 'none' }}>Save Changes</button>
                            <button onClick={() => setIsEditModalOpen(false)} style={{ padding: '8px 12px', fontSize: '14px', backgroundColor: '#dc3545', color: 'white', border: 'none' }}>Cancel</button>
                        </div>
                    </div>
                </div>

            )}
        </>

    );
};

export default SendMessaging;
